<template>
    <div class="testimonial_container">
        <div class="testimonial" v-html="testimonial.testimonial" />
        <hr>
        <div class="username">{{ testimonial.username }}</div>
        <div class="entity">{{ testimonial.entity }}</div>
        <a :href="'/' + $t('rewriting.passenger-feedback-url') + '.html'" class="see-more-link">{{ $t('home.see-more-testimonials') }}</a>
    </div>
</template>

<script>
export default {
    props: {
        testimonials: {
            required: true,
        },
    },
    data() {
        return {
            largeScreen: document.documentElement.clientWidth >= 768,
        };
    },
    computed: {
        testimonial() {
            if (this.testimonials.length > 0) {
                const index = Math.floor(Math.random() * this.testimonials.length);
                return this.testimonials[index];
            } else {
                return {};
            }
        },
    },
};
</script>
<style lang="scss" scoped>
@import "~styles/_variables";
.testimonial_container {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 800px;
    @media (max-width: 820px) {
        max-width: calc(100% - 20px);
    }
    margin-left: auto;
    margin-right: auto;
    .testimonial {
        font-family: 'Spartan';
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        margin-top: 30px;
    }
    hr {
        width: 80px;
        margin: 15px 0;
    }
    .username {
        font-style: normal;
        font-weight: 700;
        font-size: 12px;
        line-height: 17px;
    }
    .entity {
        font-style: normal;
        font-size: 12px;
        line-height: 17px;
    }
    .see-more-link {
        font-weight: 700;
        font-size: 16px;
        line-height: 22px;
        text-align: center;
        text-decoration-line: underline;
        color: white;
        margin-top: 50px;
    }
    .see-more-link:hover {
        color: white;
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/HomeTestimonials.vue